import type { DevScenario } from '@arya/shared/domain';
import { hasDevScenario } from '@arya/shared/domain';

import type { HttpCustomPredicate } from 'msw';

import type { DevRoute } from './dev-route';
import { matchRoute } from './match-route';
import type { RouteParams } from './route-params';

export const devScenarioRequest =
  <Path extends string>(route: DevRoute<Path>, scenario: DevScenario): HttpCustomPredicate<RouteParams<Path>> =>
  ({ request }) => {
    const params = hasDevScenario(request, scenario) ? matchRoute(route, request) : undefined;
    return params === undefined ? false : { matches: true, params };
  };
